import { getApiBaseUrl } from './env';

/** @see maison/client `socketUrl.js` `isChatSocketClientEnabled` */
export function isChatSocketClientEnabled() {
  const flag = (process.env.REACT_APP_CHAT_USE_SOCKET || '').trim().toLowerCase();
  if (flag === 'false' || flag === '0' || flag === 'off' || flag === 'no') return false;
  if (flag === 'true' || flag === '1' || flag === 'on' || flag === 'yes') return true;
  if ((process.env.REACT_APP_SOCKET_ORIGIN || '').trim()) return true;
  try {
    const api = getApiBaseUrl();
    if (/vercel\.app/i.test(api)) return false;
  } catch {
    /* ignore */
  }
  return true;
}

/**
 * See maison `socketUrl.js`: optional `REACT_APP_SOCKET_ORIGIN` when Socket.IO is not
 * served from the same origin as the REST API (e.g. Vercel API vs Node on Railway).
 */
export function getSocketOrigin() {
  const raw = (process.env.REACT_APP_SOCKET_ORIGIN || '').trim();
  if (raw) {
    try {
      const href = /^https?:\/\//i.test(raw) ? raw : `https://${raw}`;
      return new URL(href).origin;
    } catch {
      /* fall through */
    }
  }

  const base = getApiBaseUrl();
  try {
    const url = new URL(base);
    return url.origin;
  } catch {
    if (typeof window !== 'undefined' && window.location?.origin) return window.location.origin;
    return '';
  }
}

